<template lang="html">
  <nav class="fc-m-paginate">
    <button
      v-bind:class="{ disabled: previous == null }"
      class="btn btn-outline-primary btn-sm fc-m-paginate__button"
      v-on:click="nextPage('previous')"
    >
      <svg class="fc-a-icon fc-a-icon--blue fc-m-paginate__arrow">
        <use xlink:href="#icon_previous" />
      </svg>
    </button>
    <button
      v-bind:class="{ disabled: next == null }"
      class="btn btn-outline-primary btn-sm fc-m-paginate__button"
      v-on:click="nextPage('next')"
    >
      <svg class="fc-a-icon fc-a-icon--blue fc-m-paginate__arrow">
        <use xlink:href="#icon_next" />
      </svg>
    </button>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: ["next", "previous"],
  methods: {
    nextPage: function(direction) {
      if (this[direction] != null) {
        this.$emit("newPage", this[direction]);
      }
    }
  }
};
</script>

<style lang="scss"></style>
